import ItemConnectionsList from '@app/components/ItemConnectionsList'
import SearchBar from '@app/components/SearchBar'
import { bindFunctions } from '@app/utils/class'
import * as React from 'react'
import DocumentTitle from 'react-document-title'
import { PropertyPageProps } from './PropertyPage'

interface IPropertyConnectionsState {
  filterText: string
}

export default class PropertyConnections extends React.PureComponent<
  PropertyPageProps,
  IPropertyConnectionsState
> {
  constructor(props: PropertyPageProps) {
    super(props)

    this.state = {
      filterText: '',
    }

    bindFunctions(this)
  }

  public render() {
    return (
      <DocumentTitle title={`${this.props.property.name} :: Connections`}>
        <div className='mb-3'>
          <SearchBar
            className='mt-3'
            value={this.state.filterText}
            onChange={this._setFilterText}
            placeholder='Filter connections...'
            size='sm'
          />
          {this._renderConnections()}
        </div>
      </DocumentTitle>
    )
  }

  private _renderConnections() {
    const mergedConnections = this.props.property.associated
      .concat(this.props.property.owners)
      .toList()

    const filteredConnections = !this.state.filterText
      ? mergedConnections
      : mergedConnections
          .filter(
            (c) =>
              c !== undefined &&
              c.name
                .toLowerCase()
                .indexOf(this.state.filterText.toLowerCase()) > -1,
          )
          .toList()

    return (
      <ItemConnectionsList className='mt-3' connections={filteredConnections} />
    )
  }

  private _setFilterText(newFilterText: string) {
    this.setState({ filterText: newFilterText })
  }
}
